module.exports = "../study/imgs/maps/Kanagawa/GWQ8/Climate/Temperature/Kanagawa_Temperature_MRI_RCP85_End.png";